"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatTime = exports.keyboardControls = undefined;

var _keyboardControls2 = require("./keyboard-controls");

var _keyboardControls3 = _interopRequireDefault(_keyboardControls2);

var _formatTime2 = require("./format-time");

var _formatTime3 = _interopRequireDefault(_formatTime2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.keyboardControls = _keyboardControls3.default;
exports.formatTime = _formatTime3.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-media-player/lib/utils/index.js
// module id = 310
// module chunks = 0